import { render, staticRenderFns } from "./TypicalRoot.vue?vue&type=template&id=18a29153&lang=pug&"
import script from "./TypicalRoot.vue?vue&type=script&lang=js&"
export * from "./TypicalRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a29153')) {
      api.createRecord('18a29153', component.options)
    } else {
      api.reload('18a29153', component.options)
    }
    module.hot.accept("./TypicalRoot.vue?vue&type=template&id=18a29153&lang=pug&", function () {
      api.rerender('18a29153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/TypicalRoot.vue"
export default component.exports